import React from 'react';
import { FadeIn } from './ui/FadeIn';
import { ClockIcon, CheckCircle2Icon } from 'lucide-react';
export function ProductIntro() {
  return <section className="bg-[#1B2A4A] text-white py-20 px-6" data-id="element-326">
      <div className="max-w-4xl mx-auto" data-id="element-327">
        <FadeIn data-id="element-328">
          <div className="text-center mb-16" data-id="element-329">
            <span className="inline-block px-4 py-1 rounded-full bg-[#3BBFAD]/20 text-[#3BBFAD] text-sm font-semibold tracking-wider mb-4 border border-[#3BBFAD]/30" data-id="element-330">
              PRESENTANDO
            </span>
            <h2 className="font-serif text-4xl md:text-5xl mb-6" data-id="element-331">
              La Ruta Clara{' '}
              <span className="text-[#3BBFAD] text-3xl block mt-2" data-id="element-332">
                (18–24 meses)
              </span>
            </h2>
            <p className="text-xl text-gray-300 max-w-2xl mx-auto leading-relaxed" data-id="element-333">
              Una guía práctica para padres que te lleva de{' '}
              <span className="italic text-white" data-id="element-334">
                "No sé si esto es normal"
              </span>{' '}
              a{' '}
              <span className="font-semibold text-[#3BBFAD]" data-id="element-335">
                "Tengo un plan"
              </span>
              .
            </p>
          </div>

          <div className="grid md:grid-cols-2 gap-12 items-center" data-id="element-336">
            <div className="space-y-6" data-id="element-337">
              <div className="flex items-start gap-4" data-id="element-338">
                <div className="bg-[#3BBFAD] p-2 rounded-lg mt-1" data-id="element-339">
                  <ClockIcon className="w-6 h-6 text-[#1B2A4A]" data-id="element-340" />
                </div>
                <div data-id="element-341">
                  <h3 className="text-xl font-serif mb-2" data-id="element-342">
                    En 30–45 minutos vas a:
                  </h3>
                  <ul className="space-y-4 text-gray-300" data-id="element-343">
                    <li className="flex gap-3" data-id="element-344">
                      <CheckCircle2Icon className="w-5 h-5 text-[#3BBFAD] shrink-0 mt-1" data-id="element-345" />
                      <span data-id="element-346">
                        Entender qué señales importan en contexto (sin listas
                        infinitas)
                      </span>
                    </li>
                    <li className="flex gap-3" data-id="element-347">
                      <CheckCircle2Icon className="w-5 h-5 text-[#3BBFAD] shrink-0 mt-1" data-id="element-348" />
                      <span data-id="element-349">
                        Diferenciar 18 vs 24 meses para tomar mejores decisiones
                      </span>
                    </li>
                    <li className="flex gap-3" data-id="element-350">
                      <CheckCircle2Icon className="w-5 h-5 text-[#3BBFAD] shrink-0 mt-1" data-id="element-351" />
                      <span data-id="element-352">
                        Usar un tracker de 7 días que te da evidencia simple
                      </span>
                    </li>
                    <li className="flex gap-3" data-id="element-353">
                      <CheckCircle2Icon className="w-5 h-5 text-[#3BBFAD] shrink-0 mt-1" data-id="element-354" />
                      <span data-id="element-355">Seguir un plan de 14 días con pasos concretos</span>
                    </li>
                  </ul>
                </div>
              </div>
            </div>

            <div className="bg-white/5 p-8 rounded-2xl border border-white/10 backdrop-blur-sm" data-id="element-356">
              <p className="font-serif text-2xl mb-6 text-center" data-id="element-357">
                De la duda a la acción
              </p>
              <div className="space-y-4" data-id="element-358">
                <div className="bg-white/10 p-4 rounded-lg text-center text-gray-400 text-sm" data-id="element-359">
                  "No sé si es una señal..."
                </div>
                <div className="flex justify-center" data-id="element-360">
                  <div className="h-8 w-0.5 bg-[#3BBFAD]" data-id="element-361"></div>
                </div>
                <div className="bg-[#3BBFAD] p-4 rounded-lg text-center text-[#1B2A4A] font-bold shadow-lg transform scale-105" data-id="element-362">
                  "Sé qué observar. Sé qué registrar. Sé qué pedir."
                </div>
              </div>
            </div>
          </div>
        </FadeIn>
      </div>
    </section>;
}